	export enum InventoryOrderStatusEnum {
		PendingOrder = 1,
		Ordered = 2,
		PartiallyReceived = 3,
		Received = 4,
		Voided = 5,
		Canceled = 6,
		Returned = 7,
		New = 8,
		Rejected = 9,
		OIOrdered = 10,
		OIPartiallyShipped = 11,
    OIShipped = 12,
    Requested = 13
	}
